

const DateUtils = {
    getDay(timestamp) {
        const date = new Date(timestamp * 1000);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    },

    getDayCode(dayStr) {
        if (!dayStr.includes('.')) return dayStr.trim();
        const [code] = dayStr.split('.');
        return code.trim();
    },

    formatDayOnly(dayStr, t) {
        if (!dayStr.includes('.')) return dayStr;

        const [dayCodeRaw, dayNumRaw] = dayStr.split('.');
        const dayCode = dayCodeRaw.trim();
        let dayNumber = (dayNumRaw || '1').trim();

        const dayTranslation = t("days." + dayCode);

        // Next year check if Dec 31
        const now = new Date();
        const isDec31 = now.getDate() === 31 && now.getMonth() === 11;
        let suffix = '';
        if (isDec31 && dayNumber === '1') {
            suffix = ' (next year)';
        }

        return `${dayTranslation} ${dayNumber}${suffix}`;
    },
}

export default DateUtils;